'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gallery = require('./gallery.html');

var _gallery2 = _interopRequireDefault(_gallery);

var _gallery3 = require('./gallery.controller');

var _gallery4 = _interopRequireDefault(_gallery3);

require('./gallery.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var galleryComponent = {
  bindings: {
    item: "=",
    language: "<",
    reinit: "&"
  },
  template: _gallery2.default,
  controller: _gallery4.default,
  controllerAs: "vm"
};

exports.default = galleryComponent;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/gallery/gallery.component.js